import React, { useEffect, useRef, useState } from 'react';
import './home.css';
import logoDripp from './../assets/lovedripp.png';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const slidesData = [
  { title: 'LoveDripp', description : "Welcome to lovedripp, a platform to host and share your love memories.", link: "/how-to", blend: 'red' },
  { title: 'Onsites',  description : "Use a digital invitation for your your wedding.", link: "/onsites", blend: 'dark' },
  { title: 'Annisites', description: "Capture every anniversary moment", link: "/annisites", blend: 'red' },
  { title: 'About', description: "Start loading your onvite or annisite today!" , link: "/about", blend: 'blue' },
];

const Slide = ({ slide, isActive, index }) => (
  <div className={`fnc-slide m--blend-${slide.blend} ${isActive ? 'm--active-slide' : ''} fnc-slide-${index + 1}`}>
    <div className="fnc-slide__inner">
      <div className="fnc-slide__mask">
        <div className="fnc-slide__mask-inner" />
      </div>
      <img className="logo-dripp" src={logoDripp} />
      <div className="fnc-slide__content">
        <h2 className="fnc-slide__heading">       
            <div className="fnc-slide__heading-line" >
              <span>{slide.title}</span>
            </div>       
        </h2>
        <div className="fnc-down-sub">
          <div className="description-home">{slide.description}    </div>
          {
            slide?.link && (
              <Link type="button" className="fnc-slide__action-btn" to={slide.link}>
                OPEN <span data-text="OPEN">OPEN</span>
              </Link>
            )
          }
          
        </div>
                
      </div>
    </div>
  </div>
);

function HomeScreen() {

  const [currentSlide, setCurrentSlide]               = useState(0);
  const [autoSlide, setAutoSlide]                     = useState(true);

  const timeoutRef                                    = useRef(null);

  
  useEffect(() => {
    if (autoSlide) {
      timeoutRef.current = setTimeout(() => {
        setCurrentSlide((prev) => (prev + 1) % slidesData.length);
      }, 4000);
    }

    return () => clearTimeout(timeoutRef.current);
  }, [currentSlide, autoSlide]);

  const handleControlClick = (index) => {
    setAutoSlide(false); // block autosliding after click
    setCurrentSlide(index);
  };


  return (
    <div className="demo-cont">
      <Helmet>
              <title>Lovedripp - Home </title>
      </Helmet>
      
      <div className="fnc-slider example-slider">
        <div className="fnc-slider__slides">
          {slidesData.map((slide, index) => (
            <Slide key={index} slide={slide} index={index} isActive={index === currentSlide} />
          ))}
        </div>

        <nav className="fnc-nav">
          <div className="fnc-nav__bgs">
            {slidesData.map((s, i) => (
              <div
                key={i}
                className={`fnc-nav__bg m--navbg-${s.blend} ${
                  i === currentSlide ? 'm--active-nav-bg' : ''
                } fnc-nav__bg-${i + 1}`}
              />
            ))}
          </div>

          <div className="fnc-nav__controls">
            {slidesData.map((s, i) => (
              <button
                key={i}
                className={`fnc-nav__control fnc-nav__control-${i + 1} ${
                  i === currentSlide ? 'm--active-control' : ''
                }`}
                onClick={() => handleControlClick(i)}
              >
                {s.title}
                <span className="fnc-nav__control-progress" />
              </button>
            ))}
          </div>
        </nav>
      </div>
    </div>
  )
}

export default HomeScreen